/**
 * Selection of the bank attachments in the bank block fragments, as the page fragment selects
 * `bank.attachments` (`AttachmentList`, `ZipDownload`).
 */
export const PROJECT_BANK_ATTACHMENT_SELECTION = `
  attachments {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
    attachmentType
    createdAt
  }
`;
